'use strict';

require('es6-shim');

require('function.prototype.name/shim')();

require('./es2016');



//////////////////
// WEBPACK FOOTER
// ./node_modules/airbnb-js-shims/target/es2015.js
// module id = 1567
// module chunks = 0